<!-- 
Navigation column for tables.

This is a hidden left most column, used to provide keyboard accessibility for tables.
-->
<template>
  <td class="navCol">
    <a 
      href="#" 
      @focus="enter($event.target)" 
      @blur="leave($event.target)"
      @click.stop.prevent="click($event.target)"
      @keydown.up="prev($event.target)"
      @keydown.down="next($event.target)"
    >Press enter to select {{ row }}</a>
  </td>
</template>

<script>
export default {
  props: {
    row: {
      default: "row",
      type: String
    }
  },
  methods: {
    enter(target) {
      target.closest("tr").classList.add("navSelected");
    },
    leave(target) {
      target.closest("tr").classList.remove("navSelected");
    },
    click(target) {
      target.closest("tr").click();
    },
    prev(target) {
      var previousSibling = target.closest("tr").previousSibling;
      if (previousSibling !== null) {
        previousSibling.getElementsByClassName("navCol")[0].firstChild.focus();
      }
    },
    next(target) {
      var nextSibling = target.closest("tr").nextSibling;
      if (nextSibling !== null) {
        nextSibling.getElementsByClassName("navCol")[0].firstChild.focus();
      }
    }
  }
};
</script>
